/* eslint-disable @typescript-eslint/no-explicit-any */
interface TranslationMap {
  [key: string]: string | ((...args: any) => any);
}

function getTranslationFunction<T extends TranslationMap>(translations: T) {
  return function t<K extends keyof T, V extends T[K]>(
    k: K,
    ...args: V extends (...args: any) => any ? Parameters<V> : never[]
  ): string {
    return typeof translations[k] === "string"
      ? translations[k]
      : (translations[k] as any)(...(args as any));
  };
}

export default getTranslationFunction;
